import React from 'react';
import { styled } from '@compiled/react';
import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { Props } from './types';

const MenuListContent = (props: Props) => {
	const { children, ...restProps } = props;
	return (
		// @ts-expect-error - TS2740 - Type '{ children: Element; isLoading?: boolean | undefined; maxHeight?: number | undefined; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
		<components.MenuList {...restProps}>
			<MenuWrapper>{children}</MenuWrapper>
		</components.MenuList>
	);
};

export default MenuListContent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MenuWrapper = styled.div({
	margin: `${token('space.150', '12px')} 0`,
});
